module.exports = __webpack_public_path__ + "static/media/close-icon.64a5490e.svg";